import { render, staticRenderFns } from "./PrestadorServico.vue?vue&type=template&id=649008a2"
import script from "./PrestadorServico.vue?vue&type=script&lang=js"
export * from "./PrestadorServico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports